import {
  ProcessReceivingBarcodeResponse,
  ReceivingDownloadResponse,
  ReceivingUIResponse,
} from "../../models/ApiResponse";
import { ProcessBarcodeRequest } from "../../models/requestModels/processBarcode";
import { ReceivingResponse } from "../../models/responseModels/receivingResponse";
import { axiosRequests } from "../axiosRequest";

export const ReceivingAgent = {
  getReceivingList: () =>
    axiosRequests.get<ReceivingUIResponse>("/receiving/GetReceivingList"),
  receivingCsvDownload: (receivingData: ReceivingResponse[]) =>
    axiosRequests.post<ReceivingDownloadResponse>(
      "/receiving/DownloadCsv",
      receivingData
    ),
  receivingXlsxDownload: (receivingData: ReceivingResponse[]) =>
    axiosRequests.postXlsx<Blob>("/receiving/DownloadXlsx", receivingData),
  processBarcodeForReceiving: (processBarcodeRequest: ProcessBarcodeRequest) =>
    axiosRequests.post<ProcessReceivingBarcodeResponse>(
      "/receiving/ProcessBarcode",
      processBarcodeRequest
    ),
};
